export default {
  'entityName': 'country',
  pagination: {
    'itemsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  filterStorage: {},
  'fields': [

    {
      value: 'code',
      text: 'Code',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
      ]
    },

    
    {
      value: 'name',
      text: 'Name',
      type: 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      default: null,
    },

  

  ],
  actions: [
    'upsert','remove'
  ]
}
